import CustomText from "@components/CustomText";
import React, { useState } from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { getRvpOrderDetails } from "@services/api";
import { useNavigation } from "@react-navigation/native";

const ReturnLagaye = ({ info = {} }) => {
  const navigation = useNavigation();
  const [apiCall, setApiCall] = useState(false);

  const makeReturn = async () => {
    if (apiCall) return;
    setApiCall(true);
    if (info?.return_type === "CX_RTO") {
      navigation.navigate("ReturnCompleteOrder", {
        order_id: info?.order_id,
      });
    } else {
      const { data } = await getRvpOrderDetails(info?.order_id);
      const rvpData =
        data?.items && Array.isArray(data?.items)
          ? data?.items?.filter((v) => v?.order_item_id === info?.order_item_id)
          : [];
      if (rvpData.length) {
        navigation.navigate("SelectProduct", {
          rvpData: rvpData[0],
        });
      }
    }
    setApiCall(false);
  };
  return (
    <TouchableOpacity
      testID="return_lagaye"
      style={styles.returnButton}
      onPress={() => makeReturn()}
    >
      <CustomText
        variant="body_text_2"
        style={{ color: "rgba(0, 0, 0, 0.86)" }}
      >
        रिटर्न लगाएं
      </CustomText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  returnButton: {
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.20)",
    paddingVertical: 7,
    marginTop: 16,
  },
});

export default ReturnLagaye;
